import React from "react";
import styles from './styles.module.scss';

export const IntegrationSectionHeaders = ({ header }) => {
    return (
        <div className={styles.header}>
            {header}
        </div>
    );
};